const userDataFormValidationFR = {
    "firstName": {
        "required": "Le prénom est requis"
    },
    "lastName": {
        "required": "Le nom de famille est requis"
    },
    "personalStreet": {
        "required": "La rue et le numéro sont requis"
    },
    "personalZip": {
        "required": "Le code postal est requis"
    },
    "personalCity": {
        "required": "La ville est requise"
    },
    "personalCountry": {
        "required": "Le pays est requis"
    },
    "businessType": {
        "required": "Le type d'entreprise est requis"
    },
    "companyName": {
        "required": "Le nom de l'entreprise est requis"
    },
    "ceoFirstName": {
        "required": "Le prénom du PDG est requis"
    },
    "ceoLastName": {
        "required": "Le nom de famille du PDG est requis"
    },
    "businessStreet": {
        "required": "La rue et le numéro sont requis"
    },
    "businessZip": {
        "required": "Le code postal est requis"
    },
    "businessCity": {
        "required": "La ville est requise"
    },
    "businessCountry": {
        "required": "Le pays est requis"
    },
    "tradeRegistryExport": {
        "file": "Veuillez télécharger un fichier PDF valide (taille max 5 Mo)."
    },
    "tradeRegistryExportURL": {
        "required": "L'export du registre du commerce est requis"
    },
    "tradeRegistryCompanyUrl": {
        "required": "L'URL de l'entreprise du registre du commerce est requise"
    }
};

export default userDataFormValidationFR;